import WarningBeforeAction from "e.sic-platform.webclient/src/components/data-components/WarningBeforeAction";
import { observer } from "mobx-react-lite";
import { FormikValues } from "formik";
import { UserProfileEditInput } from "e.sic-platform.webclient/src/api-models/request/UserInput";
import { useCallback, useState } from "react";
import { CurrentUserProfileStorageModel } from "e.sic-platform.webclient/src/services/user/CurrentUserProfileStorage";
import { api } from "e.sic-platform.webclient/src/services/api/ApiService";
import Form from "e.sic-platform.webclient/src/components/form/Form";
import AddressFieldsForm from "e.sic-platform.webclient/src/components/form-fields/AddressFieldsForm";

export interface CheckoutModalProps {
    confirmationPending: boolean;
    setConfirmationPending(pending: boolean): void;
    onConfirm(): void;
}

export default observer(function CheckoutModal(props: CheckoutModalProps) {
    const {confirmationPending, setConfirmationPending, onConfirm} = props;

    const [currentUserProfileStorage] = useState(
        CurrentUserProfileStorageModel.create({}, {api})
    );

    const updateUserProfileDetails = useCallback(async (values: FormikValues) => {
        if (await currentUserProfileStorage.addressProvided() && values === currentUserProfileStorage.currentUser) onConfirm();
        else {
            const user: UserProfileEditInput = {
                firstName: values.firstName,
                userName: values.userName,
                lastName: values.lastName,
                email: values.email,
                phone: values.phone || null,
                address: values.address,
                addressNumber: values.addressNumber,
                city: values.city,
                country: values.country,
                state: values.state,
                vat: values.vat,
                zip: values.zip
            };
            await currentUserProfileStorage.editMyUserProfileDetails(user);
            onConfirm();
        }
    }, [currentUserProfileStorage, onConfirm]);

    return (
        <Form
            readonly
            formikOptions={{
                initialValues: currentUserProfileStorage.currentUser,
                onSubmit: updateUserProfileDetails,
                validateOnBlur: false,
                validateOnChange: false,
            }}
            onCancel={() => {}}
        >
            {({ values, setFieldValue, submitForm }) => (
                <WarningBeforeAction
                    titleKey="shop.confirm-title"
                    isVisible={confirmationPending}
                    toggleModal={() => setConfirmationPending(!confirmationPending)}
                    buttonOk={{
                        textKey: "shop.buy",
                        action: submitForm
                    }}
                >
                    <AddressFieldsForm values={values} setFieldValue={setFieldValue} edit={true}/>
                </WarningBeforeAction>
            )}
        </Form>
    )
})